import { DatasourceListViewData, DatasourceState, DatasourceStoreModel, DatasourceUIModel } from '@y42/datasource';
import { SqlModelingSettings } from '@y42/json-schema';
import { SqlTable } from '../models';

export class SqlModelingSettingsGitModel extends SqlModelingSettings {
  constructor(model: SqlModelingStoreModel) {
    super();
    const settings = model.settings;
    this.$schema = settings.$schema;
    this.tablesOrder = settings.tablesOrder;
  }
}

export class SqlModelingStoreModel extends DatasourceStoreModel<SqlModelingSettingsGitModel> {}

export interface SqlModelingUIModel extends DatasourceUIModel<SqlModelingStoreModel> {
  getSqlModel?: () => Promise<SqlTable[] | undefined | null>;
  setSqlQuery?: (tableName: string, sqlQuery: string) => Promise<void>;
}

export type SqlModelingState = DatasourceState<SqlModelingStoreModel>;

export type SqlModelingListViewData = DatasourceListViewData;
